//Getters เอาไว้ get ค่า state ออกมา
export const getters = {
  getInsureCompany(state) {
    return state.insureCompany
  },
  appTitle(state) {
    return state.appName
  },
  getUser(state) {
    return state.user
  },
  getUserData(state) {
    return state.userData
  },
  getMember(state) {
    return state.member
  },
  getRegisId(state) {
    return state.regisId
  },
  getUid(state) {
    return state.uid
  },
  getEmail(state) {
    return state.mail
  },
  getError(state) {
    return state.error
  },
  getLoading(state) {
    return state.loading
  },
  getSuccess(state) {
    return state.success
  },
  getLayout(state) {
    return state.layout
  },
  getAgents(state) {
    return state.agents
  },
}



// WEBPACK FOOTER //
// ./src/store/getters.js